import { useState, useRef, type ChangeEvent, type DragEvent, useEffect } from "react"
import { useIntl } from "react-intl"
import Select, { type OptionProps, components } from 'react-select'
import {Badge, Form, Image, Modal, Button as RButton} from 'react-bootstrap'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import EastIcon from '@mui/icons-material/East';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import AddIcon from '@mui/icons-material/Add';
import { FC } from "react";
import { InvoiceMultiPageSetting, InvoicePages } from "../../interfaces/Invoices";
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { FileUploader } from "react-drag-drop-files";
import { Spinner } from "react-bootstrap"
import { styled } from "@mui/material/styles"
import Box from "@mui/material/Box"
import Paper from "@mui/material/Paper"
import Typography from "@mui/material/Typography"
import Avatar from "@mui/material/Avatar"
import IconButton from "@mui/material/IconButton"
import TextField from "@mui/material/TextField"
import SendIcon from "@mui/icons-material/Send"
import EmojiEmotionsIcon from "@mui/icons-material/EmojiEmotions"
import AttachFileIcon from "@mui/icons-material/AttachFile"
import MoreVertIcon from "@mui/icons-material/MoreVert"
import PhoneIcon from "@mui/icons-material/Phone"
import VideocamIcon from "@mui/icons-material/Videocam"
import ArrowBackIcon from "@mui/icons-material/ArrowBack"
import { convertWhatsappToHtml } from "../../functions/general";
import { toAbsoluteUrl } from "../../_metronic/helpers";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { MAX_FILE_SIZE } from "../../constant/General";

// ======================================================= Loading Fetch =======================================================

export const LoadingInvoiceContent = ({spinnerType='grow', qty=3, size='sm', style={height:"500px"}}: {spinnerType?: 'border' | 'grow', qty?: number, size?: 'sm'|undefined, style?: React.CSSProperties}) => {
  return (
    <div
      className='d-flex flex-column justify-content-center align-items-center gap-4'
      style={{ ...style }}
    >
      <div className='d-flex justify-content-center align-items-center gap-2'>
        {Array.from({ length: qty }, (_, i) => (
          <Spinner key={i} animation={spinnerType} size={size} role='status'>
            <span className='visually-hidden'>Loading...</span>
          </Spinner>
        ))}
      </div>
    </div>
  )
}

// ======================================================= Footer Steps button =======================================================
interface InvoiceStepsProps {
    context: 'add' | 'update'
    stepForm: number,
    multiPages: InvoicePages[] | null,
    modalBtnLoading: boolean,
    setExtractPages: React.Dispatch<React.SetStateAction<boolean>>
    handleBack: () => void,
    handleModalClose: (val?: boolean) => void
}

export const InvoiceSteps: FC<InvoiceStepsProps> = ({
    context,
    stepForm,
    multiPages,
    modalBtnLoading,
    setExtractPages,
    handleBack,
    handleModalClose
}) => {
  const intl = useIntl()

  return (
    <div className={`modal-footer d-flex ${stepForm === 0 ? 'justify-content-end' : 'justify-content-between'}`}>
      {/* ------------------- Initial Form ------------------- */}
      {stepForm === 0 && (
        <div className='d-flex flex-stack justify-content-between gap-4'>
          <button type='button' onClick={()=>{handleModalClose(false)}} className='btn btn-light'>
            {intl.formatMessage({id: 'FORM.ACTION.CLOSE'})}
          </button>
          <button type='submit' className='btn btn-primary'>
            {intl.formatMessage({id: 'FORM.ACTION.CONTINUE'})} <EastIcon />
          </button>
        </div>
      )}

      {/* ------------------- Input Image Form ------------------- */}
      {stepForm === 1 && (
        <>
          <div className='d-flex gap-4'>
            <label htmlFor="" className="form-check-label fs-6 fw-bold">{intl.formatMessage({id:'INVOICE.PANEL.SET_PAGES'})}</label>
          </div>
          <div className='d-flex gap-4'>
            <button type='button' onClick={()=>{setExtractPages(false); handleBack()}} className='btn btn-light'>
              <KeyboardBackspaceIcon /> {intl.formatMessage({id: 'FORM.ACTION.BACK'})}
            </button>
            <button
              type='submit'
              disabled={multiPages && multiPages.length > 0 ? false : true}
              className={`btn btn-primary me-10 ${modalBtnLoading ? 'disabled' : ''}`}
              data-kt-indicator={modalBtnLoading ? 'on' : 'off'}
            >
              {intl.formatMessage({id: 'FORM.ACTION.CONTINUE'})} <EastIcon />
            </button>
          </div>
        </>
      )}

      {/* ------------------- Pages Form ------------------- */}
      {multiPages && multiPages.length > 0 && (
        <>
          {stepForm > 1 && stepForm < multiPages.length + 1 && (
            <>
              <div className='d-flex gap-4'>
                <label htmlFor="" className="form-check-label fs-6 fw-bold">{multiPages[stepForm - 2].name}</label>
              </div>
              <div className='d-flex gap-4'>
                <button type='button' onClick={()=>{setExtractPages(true); handleBack()}} className='btn btn-light'>
                  <KeyboardBackspaceIcon /> {intl.formatMessage({id: 'FORM.ACTION.BACK'})}
                </button>
                <button
                  type='submit'
                  className={`btn btn-primary me-10 ${modalBtnLoading ? 'disabled' : ''}`}
                  data-kt-indicator={modalBtnLoading ? 'on' : 'off'}
                  onClick={() => {
                    setExtractPages(true)
                  }}
                >
                  {intl.formatMessage({id: 'FORM.ACTION.CONTINUE'})} <EastIcon />
                </button>
              </div>
            </>
          )}

          {stepForm > 1 && stepForm === multiPages.length + 1 && (
            <>
              <div className='d-flex gap-4'>
                <label htmlFor="" className="form-check-label fs-6 fw-bold">{multiPages[stepForm - 2].name}</label>
              </div>            
              <div className='d-flex gap-4'>
                <button type='button' onClick={()=>{setExtractPages(true); handleBack()}} className='btn btn-light'>
                  <KeyboardBackspaceIcon /> {intl.formatMessage({id: 'FORM.ACTION.BACK'})}
                </button>
                <button
                  type='submit'
                  className={`btn btn-primary me-10 ${modalBtnLoading ? 'disabled' : ''}`}
                  data-kt-indicator={modalBtnLoading ? 'on' : 'off'}
                  onClick={() => {
                    setExtractPages(true)
                    window.scrollTo(0, 0)
                  }}
                >
                  {intl.formatMessage({id: 'INVOICE.PREVIEW'})} <EastIcon />
                </button>
              </div>
            </>
          )}

          {stepForm > 1 && stepForm === multiPages.length + 2 && (
            <>
              <div className='d-flex gap-4'>
                <label htmlFor="" className="form-check-label fs-6 fw-bold">{intl.formatMessage({id: 'INVOICE.PANEL.PREVIEW_PAGES'})}</label>
              </div>    
              <div className='d-flex gap-4'>
                <button type='button' onClick={()=>{setExtractPages(true); handleBack()}} className='btn btn-light'>
                  <KeyboardBackspaceIcon /> {intl.formatMessage({id: 'FORM.ACTION.BACK'})}
                </button>
                <button
                  type='submit'
                  className={`btn btn-primary me-10 ${modalBtnLoading ? 'disabled' : ''}`}
                  data-kt-indicator={modalBtnLoading ? 'on' : 'off'}
                >
                  {context === 'update' ? intl.formatMessage({id: 'FORM.ACTION.UPDATE'}) : intl.formatMessage({id: 'FORM.LABEL.ADD_GENERAL'}, {title: 'Invoice'})} <AddIcon />
                </button>
              </div>
            </>
          )}
        </>
      )}
    </div>
  )
}

// ======================================================= Options Variable Badge =======================================================
export const InvoiceVariableOptions = (props: OptionProps<any>) => {
    const intl = useIntl()
    const { data, isSelected } = props
    const InvoiceTypes = [
      { name: intl.formatMessage({id: 'MASTERS.DATATABLE.COLUMNS.PRODUCT_TITLE'}, {title: 'Multiple'}), color: '#E5E5EA', bsColor: 'dark', model: 'pipeline-multi-product' },
      { name: intl.formatMessage({id: 'FORM.LABEL.CUSTOM_COLUMN'}, {title: 'Multiple'}), color: '#E5E5EA', bsColor: 'dark', model: 'pipeline-multi-cf' }
    ]
    const modelTypes = [
      { name: intl.formatMessage({id: 'FORM.LABEL.CUSTOM_COLUMN'}), color: '#E5E5EA', bsColor: 'dark', model: 'pipeline-cf' }
    ]
    const varTypes = [
      { name: intl.formatMessage({id: 'FORM.ACTION.TEXT'}), color: '#E5E5EA', bsColor: 'primary', type: 'string' },
      { name: intl.formatMessage({id: 'FORM.ACTION.DATE'}), color: '#F7DC6F', bsColor: 'info', type: 'timestamp' },
      { name: intl.formatMessage({id: 'FORM.LABEL.NUMERIC'}), color: '#66D9EF', bsColor: 'success', type: 'number' },
      { name: intl.formatMessage({id: 'FORM.LABEL.CURRENCY'}), color: '#FFC107', bsColor: 'warning', type: 'currency' },
      { name: intl.formatMessage({id: 'FORM.LABEL.CURRENCY'}), color: '#FFC107', bsColor: 'warning', type: 'currencyString' },
      { name: intl.formatMessage({id: 'FORM.OPTION.TYPE.SINGLE_OPTION'}), color: '#8BC34A', bsColor: 'success', type: 'array' },
    ]
    
    return (
      <components.Option {...props}>
        <div className='d-flex align-items-center justify-content-between gap-4 p-0'>
          {/* <span style={{ backgroundColor: varTypes.find((v) => v.type === data.type)?.color }}>
            {varTypes.find((v) => v.type === data.type)?.name}
          </span> */}
          <div className='d-flex align-items-center justify-content-between gap-4 p-0'>
            {modelTypes.find((v) => v.model === data.model || 'pipeline-multi-cf' === data.type) &&(
              <button type="button" className="p-0 mb-2 bg-transparent border-0" data-bs-toggle="tooltip" data-bs-placement="left" title={intl.formatMessage({id: 'FORM.LABEL.CUSTOM_COLUMN'})}>
                  <InfoOutlinedIcon style={{ fontSize: '16px' }} />
              </button>
            )}
            <Badge bg={varTypes.find((v) => v.type === data.type)?.bsColor}>            
              {varTypes.find((v) => v.type === data.type)?.name}
            </Badge>
            {InvoiceTypes.find((v) => v.model === data.model) &&(
              <Badge bg={InvoiceTypes.find((v) => v.model === data.model)?.bsColor}>            
                {InvoiceTypes.find((v) => v.model === data.model)?.name}
              </Badge>
            )}
          </div>
          <span className='text-end'>{data.label}</span>
        </div>
      </components.Option>
    )
}

// ======================================================= Caption WhatsApp Preview =======================================================

// Styled components
const ChatContainer = styled(Paper)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  height: "600px",
  overflow: "hidden",
  borderRadius: theme.shape.borderRadius,
  boxShadow: theme.shadows[3],
}))

const ChatHeader = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(1.5),
  backgroundColor: "#128C7E", // WhatsApp green
  color: "white",
}))

const MessageArea = styled(Box)({
  flex: 1,
  padding: 16,
  overflowY: "auto",
  backgroundColor: "#eaeaea !important",
  backgroundSize: "cover",
  backgroundPosition: "center",
  display: "flex",
  flexDirection: "column",
  gap: 16,
})

const MessageBubble = styled(Box, {
  shouldForwardProp: (prop) => prop !== "sent",
})<{ sent?: boolean }>(({ theme, sent }) => ({
  maxWidth: "75%",
  // padding: theme.spacing(1, 2),
  borderRadius: theme.shape.borderRadius,
  backgroundColor: sent ? "#DCF8C6" : "white", // Light green for sent messages, white for received
  color: theme.palette.text.primary,
  alignSelf: sent ? "flex-end" : "flex-start",
}))

const InputArea = styled(Box)(({ theme }) => ({
  padding: theme.spacing(1.5),
  backgroundColor: "#eaeaea !important",
  borderTop: `1px solid ${theme.palette.divider}`,
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1),
}))

interface InvoicePreviewWhatsAppCaptionProps {
  showCaptionWAModal: boolean
  handleCaptionWAModalClose: (show: boolean) => void
  invoice: InvoiceMultiPageSetting
  // time: string
}

interface Message {
  id: number
  text: string | JSX.Element
  sent: boolean
  time: string
}


export const InvoicePreviewWhatsAppCaption: FC<InvoicePreviewWhatsAppCaptionProps> = ({ showCaptionWAModal, handleCaptionWAModalClose,invoice}) => {
  const intl = useIntl()

  const [messages, setMessages] = useState<Message[]>([
    // { id: 1, text: "Hey there! How are you?", sent: false, time: "10:30 AM" },
    // { id: 2, text: "I'm good, thanks! How about you?", sent: true, time: "10:32 AM" },
    // { id: 3, text: "Doing well! Are we still meeting tomorrow?", sent: false, time: "10:33 AM" },
    // { id: 4, text: "Yes, definitely! Looking forward to it.", sent: true, time: "10:35 AM" },
  ])
  const [newMessage, setNewMessage] = useState("")
  const messagesEndRef = useRef<HTMLDivElement>(null)

  const handleSendMessage = () => {
    if (newMessage.trim() === "") return

    const now = new Date()
    const hours = now.getHours()
    const minutes = now.getMinutes()
    const ampm = hours >= 12 ? "PM" : "AM"
    const formattedHours = hours % 12 || 12
    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes
    const timeString = `${formattedHours}:${formattedMinutes} ${ampm}`

    const newMsg: Message = {
      id: messages.length + 1,
      text: newMessage,
      sent: true,
      time: timeString,
    }

    setMessages([...messages, newMsg])
    setNewMessage("")

    // Simulate a reply after 1 second
    setTimeout(() => {
      const replies = [
        "That sounds great!",
        "I'll get back to you on that.",
        "Perfect, thanks!",
        "Let me check and I'll let you know.",
        "👍",
        "Sounds good to me!",
      ]

      const randomReply = replies[Math.floor(Math.random() * replies.length)]

      const replyMsg: Message = {
        id: messages.length + 2,
        text: randomReply,
        sent: false,
        time: timeString,
      }

      setMessages((prev) => [...prev, replyMsg])
    }, 1000)
  }

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault()
      handleSendMessage()
    }
  }

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" })
  }, [messages])

  useEffect(() => {
    if (invoice) {
      let htmlWACaption = convertWhatsappToHtml([invoice.caption], 'defaultValue', true)
      setMessages([
        { id: 1, text: (<div style={{ maxWidth:'336px', overflowWrap: 'break-word', fontSize: '14.2px' }} dangerouslySetInnerHTML={{ __html: htmlWACaption.replace(/&nbsp;/g, ' ') }}></div> as JSX.Element), sent: false, time: "10:30 AM" },
      ])
    }
  }, [invoice]);

  return (
    <Modal
    // ref={modalRef}
    show={showCaptionWAModal}
    onHide={() =>
      handleCaptionWAModalClose && handleCaptionWAModalClose(false)
    }
    centered
    backdrop='static'
    keyboard={false}
    size='xl'
    // fullscreen="xl-down"
    // style={{width: '1000px'}}
  >
    <Modal.Header
      closeButton
      // onHide={handleInvoiceModalClose}
    >
      <Modal.Title>{intl.formatMessage({id: 'INVOICE.PANEL.CAPTION_WA_PREVIEW'}, {title: invoice.name})}</Modal.Title>
    </Modal.Header>
    <Modal.Body style={{padding: '0px', minHeight: '400px'}}>
      <ChatContainer elevation={3}>
        {/* Chat Header */}
        <ChatHeader>
          <IconButton
            size="small"
            sx={{
              color: "white",
              mr: 1,
              display: { xs: "flex", md: "none" },
            }}
          >
            <ArrowBackIcon />
          </IconButton>
          <Avatar
            sx={{
              width: 40,
              height: 40,
              bgcolor: "#25D366",
              color: "#128C7E",
              border: "2px solid white",
            }}
          >
            JD
          </Avatar>
          <Box sx={{ ml: 2, flex: 1 }}>
            <Typography variant="subtitle1" fontWeight="medium">
              John Doe
            </Typography>
            <Typography variant="caption" sx={{ color: "#E0F2F1" }}>
              Online
            </Typography>
          </Box>
          <IconButton size="small" sx={{ color: "white" }}>
            <VideocamIcon />
          </IconButton>
          <IconButton size="small" sx={{ color: "white" }}>
            <PhoneIcon />
          </IconButton>
          <IconButton size="small" sx={{ color: "white" }}>
            <MoreVertIcon />
          </IconButton>
        </ChatHeader>

        {/* Chat Messages */}
        <MessageArea>
          {messages.map((message) => (
            <MessageBubble key={message.id} sent={message.sent}>
              <div className="d-flex gap-4 justify-content-between" style={{ background: '#efefef', margin:'4px', padding:'6px' }}>
                <div className="d-flex gap-4">
                  <img src={toAbsoluteUrl('/media/logos/pdf.png')} width={"34px"} />
                  <div className="d-flex flex-column">
                    <Typography variant="subtitle2">Invoice.pdf</Typography>
                    <Typography variant="caption" sx={{ color: "text.secondary" }}>1.2 MB (Sample)</Typography>
                  </div>
                </div>
                <IconButton size="small" color="primary">
                  <FileDownloadIcon />
                </IconButton>
              </div>
              <div className="d-flex flex-column gap-4 justify-content-between" style={{ padding: '6px 4px 5px 6px' }}>
                <Typography variant="body2">{message.text}</Typography>
                <Typography
                  variant="caption"
                  sx={{ color: "text.secondary", display: "block", textAlign: "right", mt: 0.5 }}
                >
                  {message.time}
                </Typography>
              </div>
            </MessageBubble>
          ))}
          <div ref={messagesEndRef} />
        </MessageArea>

        {/* Chat Input */}
        <InputArea>
          <IconButton size="small" color="primary">
            <EmojiEmotionsIcon />
          </IconButton>
          <IconButton size="small" color="primary">
            <AttachFileIcon />
          </IconButton>
          <Form.Control
            disabled
            type="text"
            placeholder="Type a message"
            value={newMessage}
            onChange={(e) => setNewMessage(e.target.value)}
            onKeyDown={handleKeyPress}
            style={{
              backgroundColor: "white",
              borderRadius: 4,
            }}
          />
          <IconButton
            color="primary"
            onClick={handleSendMessage}
            sx={{
              bgcolor: "#128C7E",
              color: "white",
              "&:hover": {
                bgcolor: "#0E7369",
              },
            }}
          >
            <SendIcon />
          </IconButton>
        </InputArea>
      </ChatContainer>
    </Modal.Body>
    {/* <Modal.Footer>
      <Button onClick={handleModalClose}>Close</Button>
    </Modal.Footer> */}
  </Modal>
  )
}


// ======================================================= (UNUSED) DRAG AND DROP FILE INPUT =======================================================
interface FileInputProps {
  onChange?: (file: File | null) => void
  accept?: string
  maxSize?: number // in bytes
  className?: string
}

export default function DragDropFileInput({ // UNUSED
  onChange,
  accept = "*/*",
  maxSize = MAX_FILE_SIZE, // 5MB default
  className = "",
}: FileInputProps) {
  const [isDragging, setIsDragging] = useState(false)
  const [file, setFile] = useState<File | null>(null)
  const [error, setError] = useState<string | null>(null)
  const fileInputRef = useRef<HTMLInputElement>(null)

  const handleFileChange = (selectedFile: File | null) => {
    setError(null)

    if (!selectedFile) {
      setFile(null)
      onChange?.(null)
      return
    }

    // Validate file size
    if (selectedFile.size > maxSize) {
      setError(`File size exceeds the limit (${(maxSize / (1024 * 1024)).toFixed(1)} MB)`)
      return
    }

    setFile(selectedFile)
    onChange?.(selectedFile)
  }

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    const selectedFile = e.target.files?.[0] || null
    handleFileChange(selectedFile)
  }

  const handleDragEnter = (e: DragEvent<HTMLDivElement>) => {
    e.preventDefault()
    e.stopPropagation()
    setIsDragging(true)
  }

  const handleDragLeave = (e: DragEvent<HTMLDivElement>) => {
    e.preventDefault()
    e.stopPropagation()
    setIsDragging(false)
  }

  const handleDragOver = (e: DragEvent<HTMLDivElement>) => {
    e.preventDefault()
    e.stopPropagation()
  }

  const handleDrop = (e: DragEvent<HTMLDivElement>) => {
    e.preventDefault()
    e.stopPropagation()
    setIsDragging(false)

    const selectedFile = e.dataTransfer.files?.[0] || null
    handleFileChange(selectedFile)
  }

  const handleClick = () => {
    fileInputRef.current?.click()
  }

  const handleRemoveFile = () => {
    setFile(null)
    if (fileInputRef.current) {
      fileInputRef.current.value = ""
    }
    onChange?.(null)
  }

  return (
    <div className={`w-full ${className}`}>
      <input
        type="file"
        ref={fileInputRef}
        onChange={handleInputChange}
        accept={accept}
        className="hidden"
        aria-label="File input"
      />

      {!file ? (
        <div
          onClick={handleClick}
          onDragEnter={handleDragEnter}
          onDragLeave={handleDragLeave}
          onDragOver={handleDragOver}
          onDrop={handleDrop}
          className={`border-2 border-dashed rounded-lg p-8 text-center cursor-pointer transition-colors
            ${isDragging ? "border-primary bg-primary/5" : "border-gray-300 hover:border-primary/50"}`}
        >
          <div className="flex flex-col items-center justify-center gap-2">
            <FileUploadIcon className="h-10 w-10 text-gray-400" />
            <p className="text-sm font-medium">Drag and drop your file here or click to browse</p>
            <p className="text-xs text-gray-500">
              {accept !== "*/*" ? `Accepted formats: ${accept}` : ""}
              {maxSize && ` (Max size: ${(maxSize / (1024 * 1024)).toFixed(1)} MB)`}
            </p>
          </div>
        </div>
      ) : (
        <div className="border rounded-lg p-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <FileUploadIcon className="h-5 w-5 text-primary" />
              <span className="text-sm font-medium truncate max-w-[200px]">{file.name}</span>
              <span className="text-xs text-gray-500">({(file.size / 1024).toFixed(1)} KB)</span>
            </div>
            <button onClick={handleRemoveFile} className="text-xs text-red-500 hover:text-red-700" type="button">
              Remove
            </button>
          </div>
        </div>
      )}

      {error && <p className="mt-2 text-sm text-red-500">{error}</p>}
    </div>
  )
}

// File types we want to accept
const fileTypes = ["JPG", "PNG", "PDF", "DOCX"]

export function FileUpload() { // UNUSED
  const [file, setFile] = useState<File | null>(null)

  const handleChange = (file: File) => {
    setFile(file)
    console.log("Selected file:", file)
  }

  return (
    <div className="max-w-md mx-auto p-4">
      <h1 className="text-xl font-semibold mb-4">File Upload</h1>

      <FileUploader
        handleChange={handleChange}
        name="file"
        types={fileTypes}
        maxSize={5} // in MB
        hoverTitle=" "
        dropMessageStyle={{ display: "none" }}
        children={
          <div className="border-2 border-dashed border-gray-300 rounded-lg p-8 text-center cursor-pointer hover:border-primary/50 transition-colors">
            <div className="flex flex-col items-center justify-center gap-2">
              <FileUploadIcon className="h-10 w-10 text-gray-400" />
              <p className="text-sm font-medium">Drag and drop your file here or click to browse</p>
              <p className="text-xs text-gray-500">Supported formats: {fileTypes.join(", ")} (Max: 5MB)</p>
            </div>
          </div>
        }
      />

      {file && (
        <div className="mt-4 border rounded-lg p-4">
          <div className="flex items-center gap-2">
            {/* <FileIcon className="h-5 w-5 text-primary" /> */}
            <div className="flex flex-col">
              <span className="text-sm font-medium truncate max-w-[250px]">{file.name}</span>
              <span className="text-xs text-gray-500">{(file.size / 1024).toFixed(1)} KB</span>
            </div>
            <button
              onClick={() => setFile(null)}
              className="ml-auto text-xs text-red-500 hover:text-red-700"
              type="button"
            >
              Remove
            </button>
          </div>
        </div>
      )}
    </div>
  )
}